module.exports = __webpack_public_path__ + "fonts/371d87e1aa518b07ab9569dba1542075.svg";